import Vue from 'vue'
import Router from 'vue-router'

const index = (resolve) => require(['@/page/index.vue'], resolve)
const event = (resolve) => require(['@/page/event.vue'], resolve)
const error = (resolve) => require(['@/page/error.vue'], resolve)
const data = (resolve) => require(['@/index/page4.vue'], resolve)
const faq = (resolve) => require(['@/index/faq.vue'], resolve)
const service = (resolve) => require(['@/components/service.vue'], resolve)
const privace = (resolve) => require(['@/components/privace.vue'], resolve)
const policy = (resolve) => require(['@/components/policy.vue'], resolve)
const ads = (resolve) => require(['@/event/ads/index.vue'], resolve)
const activity = (resolve) => require(['@/page/activity.vue'], resolve)

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
  },
  routes: [{
    path: '*',
    name: 'error',
    component: error
  },
  {
    path: '/',
    name: 'index',
    component: index,
    meta: {
      title: '신삼국지 모바일'
    },
    beforeEnter: function (to, from, next) {
      // console.log('from:',from);
      // console.log('to:',to);
      next()
    }
  },
  {
    path: '/event',
    name: 'event',
    component: event,
    meta: {
      title: '사전등록 이벤트'
    },
    beforeEnter: function (to, from, next) {
      // console.log('from:',from);
      // console.log('to:',to);
      next()
    }
  },
  {
    path: '/ads',
    name: 'ads',
    component: ads,
    meta: {
      title: '신삼국지 모바일'
    }
  },
  {
    path: '/data',
    name: 'data',
    component: data,
    meta: {
      title: '신삼국지 모바일'
    }
  },
  {
    path: '/faq',
    name: 'faq',
    component: faq,
    meta: {
      title: '신삼국지 모바일'
    }
  },
  {
    path: '/service',
    name: 'service',
    component: service,
    meta: {
      title: '신삼국지 모바일'
    }
  },
  {
    path: '/privace',
    name: 'privace',
    component: privace,
    meta: {
      title: '신삼국지 모바일'
    }
  },
  {
    path: '/policy',
    name: 'policy',
    component: policy,
    meta: {
      title: '신삼국지 모바일'
    }
  },
  {
    path: '/activity',
    name: 'activity',
    component: activity,
    meta: {
      title: '신삼국지 모바일 1주년 행운 룰렛'
    }
  }
  ]
  // scrollBehavior (to, from, savedPosition) {
  //   return { x: 0, y: 0 }
  // }
})



// WEBPACK FOOTER //
// ./src/router/index.js